import Env from '../base/env';
import Channels from '../base/channels';
import { module } from 'modujs';
import gsap from 'gsap';
import { SlowMo } from '../vendor/gsap-esm/EasePack';
gsap.registerPlugin(SlowMo);
import { getViewport } from '../utils/utilities';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.DOM.loopItems = this.DOM.view.querySelectorAll('.js-item');
    this.DOM.loopItemsAll = this.DOM.view.querySelectorAll('.js-item-all');
    this.DOM.getLast = this.DOM.loopItems[this.DOM.loopItems.length - 1];
    this.DOM.getLastAll =
      this.DOM.loopItemsAll[this.DOM.loopItemsAll.length - 1];

    //! VARS

    this.INVERT =
      typeof this.DOM.view.getAttribute('data-invert') != 'undefined' &&
      this.DOM.view.getAttribute('data-invert') == 1
        ? true
        : false;
    this.RAF = false;
    setTimeout(() => {
      this.resize();
    }, 1000);

    this.MOVING_X = 0;
    this.SPEED = Env.mobileCSS ? 0.5 : 5;
    if (this.DOM.view.getAttribute('data-speed') != null) {
      this.SPEED = this.DOM.view.getAttribute('data-speed') * 1;
    }
    this.SCROLL_SPEED = 0;
    this.CAN_START = false;
    //! FNs
    gsap.delayedCall(1.5, () => {
      this.funcResize = this.resize.bind(this);
      this.funcStart = this.start.bind(this);
      Channels.on('window::smartresize', this.funcResize);
      Channels.on('cover::finalize', this.funcStart);
      this.watcher();
    });
  }

  resize() {
    const viewport = getViewport();
    this.COORDS = this.DOM.getLast.getBoundingClientRect();
    // console.log(this.DOM.getLast);
    this.MOVE_X_LIMIT = (this.COORDS.width + this.COORDS.x) * -1;

    // this.MOVE_X_LIMIT = ((this.COORDS.width + this.COORDS.x) - viewport.width) * -1
    // console.log(this.COORDS);
    // console.log(this.MOVE_X_LIMIT);
  }

  start() {
    this.CAN_START = true;
    // console.log('can start');
  }

  watcher() {
    this.RAF = requestAnimationFrame(() => {
      // if(this.CAN_START == true) {
      //? get scroll speed
      if (typeof window.scrollInstance != 'undefined') {
        this.SCROLL_SPEED = window.scrollInstance.velocity;
      }
      let currentSpeed = this.SPEED + Math.abs(this.SCROLL_SPEED);

      //? set direction

      if (
        typeof window.scrollInstance != 'undefined' &&
        typeof window.scrollInstance.direction != 'undefined'
      ) {
        this.MOVING_X -= currentSpeed;
      }

      //? set limit
      if (this.MOVING_X <= this.MOVE_X_LIMIT) {
        this.MOVING_X = 0;
      } else if (this.MOVING_X >= 0) {
        this.MOVING_X = this.MOVE_X_LIMIT;
      }

      //? set limit
      // this.MOVING_X = this.MOVING_X % this.MOVE_X_LIMIT

      //? set tween
      gsap.set(this.DOM.loopItemsAll, { x: this.MOVING_X });
      // }

      //? render
      this.watcher();
    });
  }

  destroy() {
    Channels.removeListener('window::smartresize', this.funcResize);
    Channels.removeListener('cover::finalize', this.funcStart);
    cancelAnimationFrame(this.RAF);
  }
}
